// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

// (���� ����) ������ ���� ��Ű��
// import { aliases, mdi } from 'vuetify/iconsets/mdi'

export default createVuetify({
  theme: {
    defaultTheme: 'dark', // �⺻ �׸��� dark�� ����
    themes: {
      dark: {
        dark: true,
        colors: {
          // �׸����� ���ϴ� ������ ������ �� �ֽ��ϴ�.
          // �Ʒ��� �����̸�, �ʿ信 ���� Ŀ���͸���¡�ϼ���.
          background: '#000000',
          surface: '#121212',
          primary: '#BB86FC',
          secondary: '#03DAC6',
          error: '#CF6679',
        },
      },
    },
  },
  // (���� ����) ������ ��� ����
  // icons: {
  //   defaultSet: 'mdi',
  //   aliases,
  //   sets: {
  //     mdi,
  //   },
  // },
})
